// Project globalScope — the canonical home for module-level values that an
// EMITTED function body reads by bare name.
//
// frank serializes every function to a string and revives it with a bare
// indirect eval: nothing module-level is in scope there. A free identifier is
// only reachable if frank can classify it and lift it into the emitted
// `globalScope` bag. A value frank cannot statically evaluate (an object built
// with a spread, an IIFE result, a mutable `let`) falls through to the
// last-resort `constant: null` classification and the read becomes a
// guaranteed ReferenceError in the published payload.
//
// Every named export of THIS file is reachable to that lifter by name
// (toJSON.js CONTEXT_MODULES — `globalScope` is imported as a namespace and
// walked by `gatherModuleValues`), so declaring the value here — and importing
// it from here at the read site — is the supported fix.
// (WORKSPACE-SHELL-FRANK-GATE-BLOCKS-REPUBLISH-1)

// The resolved shell state defaults. `scopes.js`'s `workspaceScopedWipe` reads
// them to build each workspace-scoped key's typed empty. state.js builds the
// object with a `...appState` spread, so frank cannot evaluate it statically.
export { STATE_DEFAULTS as stateDefaults } from './state.js'

// The generated-app containment rules, as ONE namespace named `appRules`. The
// audit (functions/generatedAppAudit.js — a parity copy of @symbo.ls/app-rules
// src/audit.js) and functions/generatedAppContainment.js read every rule as
// `appRules.<RULE>` through `import * as appRules from './generatedAppRules.js'`.
// frank 3.14.792 did not classify a namespace import of a project file, so the
// lifted helpers (`auditGeneratedAppExpression`, `isSafeUrl`,
// `generatedAppRulesIntact`, `_allowlistFromRules`, `_gatedFreestyle`,
// `generatedAppViolationHint`) kept a bare namespace name that nothing bound,
// and the verify gate refused the whole shell emission. This export binds the
// namespace under the name the read sites use (frank 3.14.800+ binds it the
// same way itself). generatedAppRulesIntact still checks the shape at every
// entry point, so a wrong binding refuses every app — fail closed.
//
// The name was the one-letter `R` until @symbo.ls/app-rules 3.14.1 renamed its
// namespace binding to `appRules` and the parity copy followed: shared, canvas
// and gazer hoist a different `R` (a minified internal of
// @symbo.ls/symbolize-markdown that frank inlines), and the catalog census
// reported `R` as a colliding name.
export * as appRules from './functions/generatedAppRules.js'
